const defaultBrands = [
    'Fender',
    'Epiphone',
    'Gibson',
    'Yamaha'
];

export default defaultBrands;